import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { SeFeTranslationsLoader } from 'se-fe-translations'
import { CentralServiceResources as cs } from 'se-resource-types'

@Component({
  selector: 'se-po-persona-choice',
  templateUrl: './persona-choice.component.html',
  styleUrls: ['./persona-choice.component.scss'],
})
export class PersonaChoiceComponent implements OnInit {
  @Input() public profile: cs.Households.UserProfile
  @Output() public edit = new EventEmitter<cs.Households.UserProfile>()
  @Output() public chosen = new EventEmitter<cs.Households.UserProfile>()

  public ready = false

  constructor(
    private seFeTranslationsLoader: SeFeTranslationsLoader
  ) {
    // n00p
  }

  public ngOnInit(): void {
    this.initTranslations()
  }

  public onEdit(e: MouseEvent): void {
    e.stopImmediatePropagation()
    this.edit.emit(this.profile)
  }

  public onChosen(): void {
    this.chosen.emit(this.profile)
  }

  private initTranslations(): void {
    this.seFeTranslationsLoader.load('shared/ui-persona-choice/assets/translations').then(() => {
      this.ready = true
    })
  }
}
